module.exports = __webpack_public_path__ + "img/banner4.d73c08e1.png";